import $ from 'jquery';
import 'slick-carousel'

let mediaSlider = {
  initialize: function () {
    let $contentSlider = $('[data-content-slider]');
    $contentSlider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: false,
      dots: true,
      appendDots: '.c-content-slider__dots'
    });

    if ($contentSlider.find('.c-stage')) {
      $contentSlider.addClass('c-content-slider__slider--stage');
    }
  }
};

mediaSlider.initialize();
